import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    name: '',
    email: '',
    phone: '',
    address_1: '',
    address_2: '',
    postcode: '',
    city: '',
    country: '',
    same_delivery_address: false,
    delivery_name: '',
    delivery_email: '',
    delivery_phone: '',
    delivery_address_1: '',
    delivery_address_2: '',
    delivery_postcode: '',
    delivery_city: '',
    delivery_country: '',
    shipment_method: null
  },
  mutations: {
    setInvoiceData (state, invoiceData) {
      Object.assign(state, JSON.parse(JSON.stringify(invoiceData)));
    },
    setShipmentMethod (state, shipmentMethod) {
      Vue.set(state, 'shipment_method', shipmentMethod);
    },
  },
  getters: {
    invoiceData: (state) => state,
    shipmentMethod: (state) => state.shipment_method
  }
};
